<script>
  import { wsx } from "@axel669/zephyr";
  import { Button, LoadZone, Screen, Select, Paper, Flex, Titlebar, Text, Input } from "@axel669/zephyr";

  import { NotFoundException, BrowserMultiFormatReader } from '@zxing/library';

  const codeReader = new BrowserMultiFormatReader()

  let scanning = false;
  let selectedCamera = undefined;
  let scanningCamera = undefined;
  let barcode = '';

  $: {
    if (scanning === true && selectedCamera !== scanningCamera) {
      console.log('selected camera is different than scanning camera, restarting');
      start()
    }
  }

  const setup = async () => {
    console.log('Starting Setup; fetching camera list');

    // Get the list of input devices; each will have a label and a deviceId,
    // although it is possible for the deviceId to be undefined if there is only
    // a single camera.
    const devices = await codeReader.listVideoInputDevices();
    // devices.push({ label: 'Fake Camera', deviceId: devices[0].deviceId })
    console.log(devices);

    console.log(`found ${devices.length} camera(s)`);
    console.log(`defaulting to ${devices[0].label}`);

    // If there are no camera, then we should return an empty array back.
    if (devices.length == 0) {
      console.log(`No cameras!`);
      return [];
    }

    // Set the selected camera, then return the device map
    selectedCamera = devices[0].deviceId;
    return devices.map(e => ({ label: e.label, value: e.deviceId }));
  }

  // Start a continuous scan; scan will stop when something is found; errors are
  // dumped but we keep going.
  const start = () => {
    if (scanning === true) {
      codeReader.reset();
    }

    scanning = true;
    scanningCamera = selectedCamera;
    codeReader.decodeFromVideoDevice(scanningCamera, 'cameraPreview', (result, err) => {
      if (result) {
        console.log(result)
        barcode = result.text;
        codeReader.reset();
      }

      // NotFoundException is raised if the scanner was unable to spot a
      // barcode; we can just ignore those. Otherwise, we want to know what
      // happened.
      if (err && !(err instanceof NotFoundException)) {
        console.error(err)
        barcode = err
        codeReader.reset();
        scanning = false;
      }
    })
  }

  // When resetting the scanner, display that in the selected barcode text.
  const reset = () => {
    codeReader.reset();
    barcode = 'Cancelled';
    scanning = false;
  }
</script>

<svelte:body use:wsx={{ "@@theme": 'dark', "@@app": true, "p": "8px" }} />

<Screen>
  <Paper>
    <Titlebar slot="header">
      <Flex p="0px" gap="0px" slot="title">
        <Text title> Skanilo! </Text>
      </Flex>
    </Titlebar>

    <LoadZone source={setup()} let:result>
      <Flex direction="row">
        <Button on:click={start} m="4px" outline color="@secondary">Start</Button>
        <Select options={result} bind:value={selectedCamera} label="Camera" w.min="200px" w.max="400px" color="@secondary"/>
        <Button on:click={reset} m="4px" outline color="@danger">Reset</Button>
      </Flex>

      <Flex>
        <Input label="Scanned Barcode" disabled bind:value={barcode} />
      </Flex>

      <Flex>
        <video id="cameraPreview" use:wsx={{ "m": "4px" }} width="80%" style="border: 1px solid gray"></video>
      </Flex>
    </LoadZone>

    <Titlebar slot="footer">
      <Text slot="title" title>
        <Text subtitle>You should probably not be looking at this, it's gross.</Text>
      </Text>
    </Titlebar>
  </Paper>
</Screen>